import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const dwnldExpenseAutocrawl = async () => {
    try {
        let url = `${BaseUrl}Home/autocrawlExpenses`;
        const res = await axios.get(url, JsonConfig)
        if (res.status === 200) {
            const sample = JSON.parse(res.data)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get autocrawl data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get autocrawl data");
        return null;
    }
}

export const downloadExpenseAutoCrawledFiles = async () => {
    try {
        let url = `${BaseUrl}Home/DownloadZipFile_ExpensesPayroll?filename=AutoCrawling_User`;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: "blob",
        }
        const response = await axios.get(url, config);
        if (response.status === 200) {
            fileDownload(response.data, "ExpensesAutoCrawlFiles.zip");
        }
        else {
            ErrorMessage("Cannot able to download");
        }
    }
    catch {
        ErrorMessage("Internal error, cannot able to download");
    }
}

export const getExpensesMfData = async () => {
    try {
        let url = `${BaseUrl}Expenses/MasterFileinGrid`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data, please try again")
    }
}

export const refreshExpensesData = async() => {
    try {
        const data = {};
        let url = `${BaseUrl}Expenses/ExpensesMasterfileGeneration`
        const res = await axios.post(url, data, JsonConfig)
        if (res.data.statusCode === 200) {
            const resp = await getExpensesMfData()
            SuccessMessage(res.data.message)
            return resp;
        }
        if (res.data.statusCode === 500) {
            InfoMessage(res.data.message)
            return null;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch (err) {
        ErrorMessage("Cannot able to refresh data, please try again");
        return null;
    }
}

export const downloadExpensesMSXL = async (data) => {
    try {
        if (data.length > 0) {
            let loopedList = [];

            // Headers
            loopedList.push([
                'Name', 'Weekend Date', 'Client Name','Unique Exp ID','Amount',
                'Approval Status','File No', 'Other Exp ID', 'Processed Date', 'GLAmount', 'GLName'
            ]);

            // Function to sanitize only string values
            const sanitizeCellValue = (value) => {
                if (typeof value === 'string' && /^[=+\-@]/.test(value.trim())) {
                    return "'" + value; // Prefix with a single quote only for strings
                }
                return value;
            };

            // Loop through data and ensure numeric values stay as numbers
            for (let i = 0; i < data.length; i++) {
                loopedList.push([
                    sanitizeCellValue(data[i].Portal_Name),
                    sanitizeCellValue(data[i].Weekend_Date),
                    sanitizeCellValue(data[i].Client_Name),
                    sanitizeCellValue(data[i].UniqueExpId),
                    sanitizeCellValue(data[i].Amount),
                    sanitizeCellValue(data[i].Approved_Status),
                    sanitizeCellValue(data[i].FileNo),
                    sanitizeCellValue(data[i].OtherExpId),
                    sanitizeCellValue(data[i].ProcessedDate),
                    sanitizeCellValue(data[i].GLAmount),
                    sanitizeCellValue(data[i].GLName)
                ]);
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Add rows from loopedList
            for (let i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }

            // Export as CSV
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'MastefileGridData.csv');
                });

            return "downloaded";
        } else {
            return null;
        }
    } catch {
        ErrorMessage("Cannot get masterfile data");
        return null;
    }
}
export const updateExpensesMFRow = async (props) => {
    try {
        let url = `${BaseUrl}Expenses/UpdateExpensesMasterFile`
        let data = props;
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}

export const getfolderUploadedDate = async () => {
    try{
        let url = `${BaseUrl}Home/folderUploadedDate?moduleName=expenses`
        const response = await axios.get(url,JsonConfig);
        const JsonResponse = response !== null ? response.data : null;
        if(JsonResponse != null){
            if(JsonResponse.statusCode === 200){
                return JsonResponse;
            }
            else{
                ErrorMessage(JsonResponse.message);
                return null;
            }
        }else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (err){
        ErrorMessage("Unable to resolve request")
        return null
    }
}